export const heroImages = {
  'app-contact': {
    src: '/images/hero/app-contact.jpg',
    alt: {
      nl: 'App contact',
      en: 'App contact'
    }
  },
  'cees-geeft-ton-een-maaltijd': {
    src: '/images/hero/cees-geeft-ton-een-maaltijd.jpg',
    alt: {
      nl: 'Cees geeft Ton een maaltijd',
      en: 'Cees gives Ton a meal'
    }
  },
  'fietsmandje-met-stapel-bakjes': {
    src: '/images/hero/fietsmandje-met-stapel-bakjes.jpg',
    alt: {
      nl: 'Fietsmandje gevuld met stapel maaltijdbakjes',
      en: 'Bicycle basket filled with stacked meal containers'
    }
  },
  'frans-voor-de-deur': {
    src: '/images/hero/frans-voor-de-deur.jpg',
    alt: {
      nl: 'Frans staat voor de deur',
      en: 'Frans standing in front of the door'
    }
  },
  'gabriella-en-sanne': {
    src: '/images/hero/gabriella-en-sanne.jpg',
    alt: {
      nl: 'Gabriëlla en Sanne samen',
      en: 'Gabriëlla and Sanne together'
    }
  },
  'gado-gado-in-een-bakje': {
    src: '/images/hero/gado-gado-in-een-bakje.jpg',
    alt: {
      nl: 'Gado gado geserveerd in een bakje',
      en: 'Gado gado served in a container'
    }
  },
  'hygienetips-voor-handen-wassen': {
    src: '/images/hero/hygienetips-voor-handen-wassen.jpg',
    alt: {
      nl: 'Tips voor correct handen wassen',
      en: 'Tips for proper hand washing'
    }
  },
  'ilse-bezorgt-maaltijd': {
    src: '/images/hero/ilse-bezorgt-maaltijd.jpg',
    alt: {
      nl: 'Ilse bezorgt een maaltijd',
      en: 'Ilse delivering a meal'
    }
  },
  'ilse-blendt-eten': {
    src: '/images/hero/ilse-blendt-eten.jpg',
    alt: {
      nl: 'Ilse gebruikt een blender voor het eten',
      en: 'Ilse blending food'
    }
  },
  'ilse-en-frans': {
    src: '/images/hero/ilse-en-frans.jpg',
    alt: {
      nl: 'Ilse en Frans samen',
      en: 'Ilse and Frans together'
    }
  },
  'ilse-en-frans-1': {
    src: '/images/hero/ilse-en-frans-1.jpg',
    alt: {
      nl: 'Ilse en Frans in gesprek',
      en: 'Ilse and Frans in conversation'
    }
  },
  'ilse-en-frans-2': {
    src: '/images/hero/ilse-en-frans-2.jpg',
    alt: {
      nl: 'Ilse en Frans delen een maaltijd',
      en: 'Ilse and Frans sharing a meal'
    }
  },
  'ilse-en-frans-3': {
    src: '/images/hero/ilse-en-frans-3.jpg',
    alt: {
      nl: 'Ilse en Frans in de keuken',
      en: 'Ilse and Frans in the kitchen'
    }
  },
  'ilse-en-frans-4': {
    src: '/images/hero/ilse-en-frans-4.jpg',
    alt: {
      nl: 'Ilse en Frans bereiden samen eten',
      en: 'Ilse and Frans preparing food together'
    }
  },
  'ilse-gooit-eten-in-de-pan': {
    src: '/images/hero/ilse-gooit-eten-in-de-pan.jpg',
    alt: {
      nl: 'Ilse voegt ingrediënten toe aan de pan',
      en: 'Ilse adding ingredients to the pan'
    }
  },
  'ilse-kookt-eten': {
    src: '/images/hero/ilse-kookt-eten.jpg',
    alt: {
      nl: 'Ilse bereidt een maaltijd',
      en: 'Ilse preparing a meal'
    }
  },
  'ilse-kookt-eten-1': {
    src: '/images/hero/ilse-kookt-eten-1.jpg',
    alt: {
      nl: 'Ilse bereidt ingrediënten',
      en: 'Ilse preparing ingredients'
    }
  },
  'ilse-maakt-lenterisotto': {
    src: '/images/hero/ilse-maakt-lenterisotto.jpg',
    alt: {
      nl: 'Ilse maakt lenterisotto',
      en: 'Ilse making spring risotto'
    }
  },
  'ilse-maakt-lenterisotto-1': {
    src: '/images/hero/ilse-maakt-lenterisotto-1.jpg',
    alt: {
      nl: 'Ilse bereidt lenterisotto',
      en: 'Ilse preparing spring risotto'
    }
  },
  'ilse-met-fiets': {
    src: '/images/hero/ilse-met-fiets.jpg',
    alt: {
      nl: 'Ilse staat bij haar fiets',
      en: 'Ilse standing with her bicycle'
    }
  },
  'ilse-met-stapel-bakjes': {
    src: '/images/hero/ilse-met-stapel-bakjes.jpg',
    alt: {
      nl: 'Ilse met een stapel maaltijdbakjes',
      en: 'Ilse with a stack of meal containers'
    }
  },
  'ilse-met-stapel-bakjes-1': {
    src: '/images/hero/ilse-met-stapel-bakjes-1.jpg',
    alt: {
      nl: 'Ilse houdt maaltijdbakjes vast',
      en: 'Ilse holding meal containers'
    }
  },
  'ilse-op-de-fiets': {
    src: '/images/hero/ilse-op-de-fiets.jpg',
    alt: {
      nl: 'Ilse rijdt op haar fiets',
      en: 'Ilse riding her bicycle'
    }
  },
  'ilse-raspt-kaas': {
    src: '/images/hero/ilse-raspt-kaas.jpg',
    alt: {
      nl: 'Ilse raspt kaas voor een gerecht',
      en: 'Ilse grating cheese for a dish'
    }
  },
  'ilse-snijdt-eten-in-keuken': {
    src: '/images/hero/ilse-snijdt-eten-in-keuken.jpg',
    alt: {
      nl: 'Ilse snijdt ingrediënten in de keuken',
      en: 'Ilse cutting ingredients in the kitchen'
    }
  },
  'ilse-snijdt-eten-in-keuken-1': {
    src: '/images/hero/ilse-snijdt-eten-in-keuken-1.jpg',
    alt: {
      nl: 'Ilse bereidt groenten voor',
      en: 'Ilse preparing vegetables'
    }
  },
  'ilse-snijdt-eten-in-keuken-2': {
    src: '/images/hero/ilse-snijdt-eten-in-keuken-2.jpg',
    alt: {
      nl: 'Ilse snijdt ingrediënten',
      en: 'Ilse chopping ingredients'
    }
  },
  'ilse-snijdt-eten-in-keuken-3': {
    src: '/images/hero/ilse-snijdt-eten-in-keuken-3.jpg',
    alt: {
      nl: 'Ilse bereidt een maaltijd voor',
      en: 'Ilse preparing a meal'
    }
  },
  'irene-en-haar-zoon': {
    src: '/images/hero/irene-en-haar-zoon.jpg',
    alt: {
      nl: 'Irene met haar zoon',
      en: 'Irene with her son'
    }
  },
  'irene-en-haar-zoon-1': {
    src: '/images/hero/irene-en-haar-zoon-1.jpg',
    alt: {
      nl: 'Irene en haar zoon delen tijd samen',
      en: 'Irene and her son spending time together'
    }
  },
  'irene-en-rob': {
    src: '/images/hero/irene-en-rob.jpg',
    alt: {
      nl: 'Irene en Rob samen',
      en: 'Irene and Rob together'
    }
  },
  'irene-en-rob-1': {
    src: '/images/hero/irene-en-rob-1.jpg',
    alt: {
      nl: 'Irene en Rob in gesprek',
      en: 'Irene and Rob in conversation'
    }
  },
  'jan-kookt-eten': {
    src: '/images/hero/jan-kookt-eten.jpg',
    alt: {
      nl: 'Jan bereidt een maaltijd',
      en: 'Jan preparing a meal'
    }
  },
  'kookboek-de-wereld-op-je-bord': {
    src: '/images/hero/kookboek-de-wereld-op-je-bord.jpg',
    alt: {
      nl: 'Banner van het kookboek “De wereld op je bord”',
      en: 'Banner of the cookbook “The world on your plate”'
    }
  },
  'lianne-en-gerard': {
    src: '/images/hero/lianne-en-gerard.jpg',
    alt: {
      nl: 'Lianne en Gerard samen',
      en: 'Lianne and Gerard together'
    }
  },
  'mila-en-caro': {
    src: '/images/hero/mila-en-caro.jpg',
    alt: {
      nl: 'Mila heeft een maaltijd van Caro ontvangen',
      en: 'Mila has received a meal from Caro'
    }
  },
  'nikki-zit-in-keuken': {
    src: '/images/hero/nikki-zit-in-keuken.jpg',
    alt: {
      nl: 'Nikki zit in de keuken',
      en: 'Nikki sitting in the kitchen'
    }
  },
  'parelcouscous-met-pompoen-feta-en-marokkaanse-dressing': {
    src: '/images/hero/parelcouscous-met-pompoen-feta-en-marokkaanse-dressing.jpg',
    alt: {
      nl: 'Parelcouscous met pompoen, feta en Marokkaanse dressing',
      en: 'Pearl couscous with pumpkin, feta and Moroccan dressing'
    }
  },
  'suryono-en-sanne-in-gesprek': {
    src: '/images/hero/suryono-en-sanne-in-gesprek.jpg',
    alt: {
      nl: 'Suryono en Sanne in gesprek',
      en: 'Suryono and Sanne in conversation'
    }
  },
  'suryono-maakt-bord-op': {
    src: '/images/hero/suryono-maakt-bord-op.jpg',
    alt: {
      nl: 'Suryono maakt een bord op',
      en: 'Suryono plating a dish'
    }
  },
  'suryono-met-dressing': {
    src: '/images/hero/suryono-met-dressing.jpg',
    alt: {
      nl: 'Suryono met dressing voor een gerecht',
      en: 'Suryono with dressing for a dish'
    }
  },
  'suryono-staat-in-keuken': {
    src: '/images/hero/suryono-staat-in-keuken.jpg',
    alt: {
      nl: 'Suryono staat in de keuken',
      en: 'Suryono standing in the kitchen'
    }
  },
  'suryono-staat-in-keuken-1': {
    src: '/images/hero/suryono-staat-in-keuken-1.jpg',
    alt: {
      nl: 'Suryono bereidt een maaltijd voor',
      en: 'Suryono preparing a meal'
    }
  },
  'tica-en-frans': {
    src: '/images/hero/tica-en-frans.jpg',
    alt: {
      nl: 'Tica en Frans delen een maaltijd',
      en: 'Tica en Frans share a meal'
    }
  },
  'thuisgekookt-picknick': {
    src: '/images/hero/thuisgekookt-picknick.jpg',
    alt: {
      nl: 'Thuisgekookt picknick',
      en: 'Thuisgekookt picknick'
    }
  },
  'thuisgekookt-picknick-1': {
    src: '/images/hero/thuisgekookt-picknick-1.jpg',
    alt: {
      nl: 'Thuisgekookt picknick',
      en: 'Thuisgekookt picknick'
    }
  },
  'vincent-en-irma': {
    src: '/images/hero/vincent-en-irma.jpg',
    alt: {
      nl: 'Vincent en Irma samen',
      en: 'Vincent and Irma together'
    }
  },
  'vincent-en-irma-1': {
    src: '/images/hero/vincent-en-irma-1.jpg',
    alt: {
      nl: 'Vincent en Irma delen tijd samen',
      en: 'Vincent and Irma spending time together'
    }
  },
  'vincent-kookt-eten': {
    src: '/images/hero/vincent-kookt-eten.jpg',
    alt: {
      nl: 'Vincent bereidt een maaltijd',
      en: 'Vincent preparing a meal'
    }
  },
  'vincent-kookt-eten-1': {
    src: '/images/hero/vincent-kookt-eten-1.jpg',
    alt: {
      nl: 'Vincent aan het koken in de keuken',
      en: 'Vincent cooking in the kitchen'
    }
  },
  'vincent-snijdt-eten-in-keuken': {
    src: '/images/hero/vincent-snijdt-eten-in-keuken.jpg',
    alt: {
      nl: 'Vincent snijdt ingrediënten in de keuken',
      en: 'Vincent cutting ingredients in the kitchen'
    }
  },
  'vincent-snijdt-eten-in-keuken-1': {
    src: '/images/hero/vincent-snijdt-eten-in-keuken-1.jpg',
    alt: {
      nl: 'Vincent bereidt ingrediënten voor',
      en: 'Vincent preparing ingredients'
    }
  },
  'vincent-staat-in-keuken': {
    src: '/images/hero/vincent-staat-in-keuken.jpg',
    alt: {
      nl: 'Vincent staat in de keuken',
      en: 'Vincent standing in the kitchen'
    }
  },
  'vincent-stopt-eten-in-bakje': {
    src: '/images/hero/vincent-stopt-eten-in-bakje.jpg',
    alt: {
      nl: 'Vincent doet eten in een maaltijdbakje',
      en: 'Vincent putting food in a meal container'
    }
  }
} as const

export const recipeImages = {
  'bloemkoolcurry-met-cashewnoten-en-rijst': {
    src: '/images/recepten/bloemkoolcurry-met-cashewnoten-en-rijst.jpg',
    alt: {
      nl: 'Recept voor bloemkoolcurry met cashewnoten en rijst',
      en: 'Recipe for cauliflower curry with cashews and rice'
    }
  },
  bramdijvie: {
    src: '/images/recepten/bramdijvie.jpeg',
    alt: {
      nl: 'Recept voor bramdijvie',
      en: 'Recipe for bramdijvie'
    }
  },
  broccolipasta: {
    src: '/images/recepten/broccolipasta.jpg',
    alt: {
      nl: 'Recept voor broccolipasta',
      en: 'Recipe for broccoli pasta'
    }
  },
  'burrito-bowl-met-zoete-aardappel-en-mais-salsa': {
    src: '/images/recepten/burrito-bowl-met-zoete-aardappel-en-mais-salsa.jpg',
    alt: {
      nl: 'Recept voor burrito bowl met zoete aardappel en maïs salsa',
      en: 'Recipe for burrito bowl with sweet potato and corn salsa'
    }
  },
  'cheesy-tortellini-ovenschotel-met-witte-kool-en-wortel': {
    src: '/images/recepten/cheesy-tortellini-ovenschotel-met-witte-kool-en-wortel.jpg',
    alt: {
      nl: 'Recept voor cheesy tortellini ovenschotel met witte kool en wortel',
      en: 'Recipe for cheesy tortellini casserole with white cabbage and carrot'
    }
  },
  'courgettesoep-gezond-met-rode-paprika': {
    src: '/images/recepten/courgettesoep-gezond-met-rode-paprika.jpg',
    alt: {
      nl: 'Recept voor courgettesoep met rode paprika',
      en: 'Recipe for zucchini soup with red pepper'
    }
  },
  'eenpans-orzo-met-italiaanse-groenten': {
    src: '/images/recepten/eenpans-orzo-met-italiaanse-groenten.jpg',
    alt: {
      nl: 'Recept voor eenpans orzo met Italiaanse groenten',
      en: 'Recipe for one-pan orzo with Italian vegetables'
    }
  },
  'gado-gado': {
    src: '/images/recepten/gado-gado.jpg',
    alt: {
      nl: 'Recept voor gado gado',
      en: 'Recipe for gado gado'
    }
  },
  'gezonde-lasagne-met-seizoensgroenten': {
    src: '/images/recepten/gezonde-lasagne-met-seizoensgroenten.jpeg',
    alt: {
      nl: 'Recept voor gezonde lasagne met seizoensgroenten',
      en: 'Recipe for healthy lasagna with seasonal vegetables'
    }
  },
  'hartige-pompoenpannenkoekjes-met-andijvie': {
    src: '/images/recepten/hartige-pompoenpannenkoekjes-met-andijvie.jpg',
    alt: {
      nl: 'Recept voor hartige pompoenpannenkoekjes met andijvie',
      en: 'Recipe for savory pumpkin pancakes with endive'
    }
  },
  'hollandse-groentesoep-met-gehaktballetjes': {
    src: '/images/recepten/hollandse-groentesoep-met-gehaktballetjes.jpg',
    alt: {
      nl: 'Recept voor Hollandse groentesoep met gehaktballetjes',
      en: 'Recipe for Dutch vegetable soup with meatballs'
    }
  },
  'hollandse-stoofpot-met-appelstroop': {
    src: '/images/recepten/hollandse-stoofpot-met-appelstroop.jpg',
    alt: {
      nl: 'Recept voor Hollandse stoofpot met appelstroop',
      en: 'Recipe for Dutch stew with apple syrup'
    }
  },
  'hollandse-witlofschotel': {
    src: '/images/recepten/hollandse-witlofschotel.jpg',
    alt: {
      nl: 'Recept voor Hollandse witlofschotel',
      en: 'Recipe for Dutch endive casserole'
    }
  },
  'indiase-dahl-met-pompoen-en-spinazie': {
    src: '/images/recepten/indiase-dahl-met-pompoen-en-spinazie.jpg',
    alt: {
      nl: 'Recept voor Indiase dahl met pompoen en spinazie',
      en: 'Recipe for Indian dahl with pumpkin and spinach'
    }
  },
  'indiase-kip-currysoep': {
    src: '/images/recepten/indiase-kip-currysoep-met-vegetarische-samosas.jpg',
    alt: {
      nl: 'Recept voor Indiase kip currysoep',
      en: 'Recipe for Indian chicken curry soup'
    }
  },
  'indiase-pompoencurry-met-pappadums': {
    src: '/images/recepten/indiase-pompoencurry-met-pappadums.jpg',
    alt: {
      nl: 'Recept voor Indiase pompoencurry met pappadums',
      en: 'Recipe for Indian pumpkin curry with pappadums'
    }
  },
  'keto-lasagne-met-courgette-en-gehakt': {
    src: '/images/recepten/keto-lasagne-met-courgette-en-gehakt.jpg',
    alt: {
      nl: 'Recept voor keto lasagne met courgette en gehakt',
      en: 'Recipe for keto lasagna with zucchini and minced meat'
    }
  },
  'kruidige-couscous-salade-met-gegrilde-groenten-en-olijven': {
    src: '/images/recepten/kruidige-couscous-salade-met-gegrilde-groenten-en-olijven.jpg',
    alt: {
      nl: 'Recept voor kruidige couscous salade met gegrilde groenten en olijven',
      en: 'Recipe for spiced couscous salad with grilled vegetables and olives'
    }
  },
  'loaded-paksoi': {
    src: '/images/recepten/loaded-paksoi.png',
    alt: {
      nl: 'Recept voor Loaded Paksoi',
      en: 'Recipe for Loaded Paksoi'
    }
  },
  'mama-nasi': {
    src: '/images/recepten/mama-nasi.jpg',
    alt: { nl: 'Recept voor Mama Nasi', en: 'Recipe for Mama Nasi' }
  },
  'midden-oosterse-stamppot-met-falafelballetjes': {
    src: '/images/recepten/midden-oosterse-stamppot-met-falafelballetjes.jpg',
    alt: {
      nl: 'Recept voor Midden Oosterse stamppot met falafelballetjes',
      en: 'Recipe for Middle Eastern stew with falafel balls'
    }
  },
  'moussaka-met-aardappelen': {
    src: '/images/recepten/moussaka-met-aardappelen.jpg',
    alt: {
      nl: 'Recept voor moussaka met aardappelen',
      en: 'Recipe for moussaka with potatoes'
    }
  },
  'nasi-goreng-kampoeng': {
    src: '/images/recepten/nasi-goreng-kampoeng.jpg',
    alt: {
      nl: 'Recept voor Nasi Goreng Kampoeng',
      en: 'Recipe for Nasi Goreng Kampoeng'
    }
  },
  'orzo-met-kip-tomaat-en-groene-groentes': {
    src: '/images/recepten/orzo-met-kip-tomaat-en-groene-groentes.jpg',
    alt: {
      nl: 'Recept voor orzo met kip, tomaat en groene groentes',
      en: 'Recipe for orzo with chicken, tomato and green vegetables'
    }
  },
  'orzo-salade-met-balsamicobietjes': {
    src: '/images/recepten/orzo-salade-met-balsamicobietjes.jpg',
    alt: {
      nl: 'Recept voor orzo salade met balsamicobietjes',
      en: 'Recipe for orzo salad with balsamic beets'
    }
  },
  'ouderwets-zelfgemaakte-hachee-met-rode-kool-en-aardappelpuree': {
    src: '/images/recepten/ouderwets-zelfgemaakte-hachee-met-rode-kool-en-aardappelpuree.jpg',
    alt: {
      nl: 'Recept voor ouderwets zelfgemaakte hachee met rode kool en aardappelpuree',
      en: 'Recipe for traditional homemade hachee with red cabbage and mashed potatoes'
    }
  },
  'parelcouscous-met-pompoen-feta-en-marokkaanse-dressing':
    heroImages['parelcouscous-met-pompoen-feta-en-marokkaanse-dressing'],
  'pita-falafel-met-tuinbonenhummus': {
    src: '/images/recepten/pita-falafel-met-tuinbonenhummus.jpg',
    alt: {
      nl: 'Recept voor pita falafel met tuinbonenhummus',
      en: 'Recipe for pita falafel with broad bean hummus'
    }
  },
  'pitabroodjes-met-geroosterde-groenten-falafel-en-hoemoes': {
    src: '/images/recepten/pitabroodjes-met-geroosterde-groenten-falafel-en-hoemoes.jpg',
    alt: {
      nl: 'Recept voor pitabroodjes met geroosterde groenten, falafel en hoemoes',
      en: 'Recipe for pita bread with roasted vegetables, falafel and hummus'
    }
  },
  'pittige-gochujang-noedels-met-bloemkool-en-aubergine': {
    src: '/images/recepten/pittige-gochujang-noedels-met-bloemkool-en-aubergine.png',
    alt: {
      nl: 'Recept voor Gochujang noedels met bloemkool en aubergine',
      en: 'Recipe for Gochujang noodles with cauliflower and aubergine'
    }
  },
  'poke-bowl-met-kip': {
    src: '/images/recepten/poke-bowl-met-kip.jpg',
    alt: {
      nl: 'Recept voor poke bowl met kip',
      en: 'Recipe for poke bowl with chicken'
    }
  },
  'praatje-stamppot': {
    src: '/images/recepten/praatje-stamppot.jpg',
    alt: {
      nl: 'Recept voor praatje stamppot',
      en: 'Recipe for praatje stamppot'
    }
  },
  'quiche-lorraine-a-lotte': {
    src: '/images/recepten/quiche-lorraine-a-lotte.jpeg',
    alt: {
      nl: 'Recept voor quiche lorraine a lotte',
      en: 'Recipe for quiche lorraine a lotte'
    }
  },
  'raspberry-roly-poly': {
    src: '/images/recepten/raspberry-roly-poly.png',
    alt: {
      nl: 'Recept voor raspberry roly poly',
      en: 'Recipe for raspberry roly poly'
    }
  },
  'regenboogquiche-met-courgettes-brie-en-tijm': {
    src: '/images/recepten/regenboogquiche-met-courgettes-brie-en-tijm.jpg',
    alt: {
      nl: 'Recept voor regenboogquiche met courgettes, brie en tijm',
      en: 'Recipe for rainbow quiche with courgettes, brie and tarragon'
    }
  },
  'rode-curry-papa': {
    src: '/images/recepten/rode-curry-papa.jpg',
    alt: {
      nl: 'Recept voor rode curry papa',
      en: 'Recipe for red curry pork'
    }
  },
  'romige-kip-madras-met-gele-rijst': {
    src: '/images/recepten/romige-kip-madras-met-gele-rijst.jpg',
    alt: {
      nl: 'Recept voor romige kip madras met gele rijst',
      en: 'Recipe for creamy chicken madras with yellow rice'
    }
  },
  'romige-toscaanse-garnalen': {
    src: '/images/recepten/romige-toscaanse-garnalen.jpg',
    alt: {
      nl: 'Recept voor romige Toscaanse garnalen',
      en: 'Recipe for creamy Tuscan shrimp'
    }
  },
  'romige-tuinerwten-maaltijdsoep': {
    src: '/images/recepten/romige-tuinerwten-maaltijdsoep.jpg',
    alt: {
      nl: 'Recept voor romige tuinerwten maaltijdsoep',
      en: 'Recipe for creamy garden pea soup'
    }
  },
  'shoarma-boerenkool-wrap': {
    src: '/images/recepten/shoarma-boerenkool-wrap.jpg',
    alt: {
      nl: 'Recept voor shoarma boerenkool wrap',
      en: 'Recipe for shawarma kale wrap'
    }
  },
  'snelle-pasta-met-tomaat-auberginesaus': {
    src: '/images/recepten/snelle-pasta-met-tomaat-auberginesaus.jpg',
    alt: {
      nl: 'Recept voor snelle pasta met tomaat auberginesaus',
      en: 'Recipe for quick pasta with tomato and eggplant sauce'
    }
  },
  'spaghetti-met-courgette-en-ricotta': {
    src: '/images/recepten/spaghetti-met-courgette-en-ricotta.jpg',
    alt: {
      nl: 'Recept voor spaghetti met courgette en ricotta',
      en: 'Recipe for spaghetti with zucchini and ricotta'
    }
  },
  'stamppot-boerenkool-met-worst-en-spekjes': {
    src: '/images/recepten/stamppot-boerenkool-met-worst-en-spekjes.jpg',
    alt: {
      nl: 'Recept voor stamppot boerenkool met worst en spekjes',
      en: 'Recipe for kale mash with sausage and bacon bits'
    }
  },
  'surinaams-zuurgoed': {
    src: '/images/recepten/surinaams-zuurgoed.jpg',
    alt: {
      nl: 'Recept voor Surinaams zuurgoed',
      en: 'Recipe for Surinamese pickled vegetables'
    }
  },
  'surinaamse-bami': {
    src: '/images/recepten/surinaamse-bami.jpg',
    alt: {
      nl: 'Recept voor Surinaamse bami',
      en: 'Recipe for Surinamese bami'
    }
  },
  'sweet-chili-garnalen-met-aziatische-spruitjes': {
    src: '/images/recepten/sweet-chili-garnalen-met-aziatische-spruitjes.jpg',
    alt: {
      nl: 'Recept voor sweet chili garnalen met Aziatische spruitjes',
      en: 'Recipe for sweet chili shrimp with Asian sprouts'
    }
  },
  'tagliatelle-met-aubergine-en-courgette': {
    src: '/images/recepten/tagliatelle-met-aubergine-en-courgette.jpg',
    alt: {
      nl: 'Recept voor tagliatelle met aubergine en courgette',
      en: 'Recipe for tagliatelle with eggplant and zucchini'
    }
  },
  'tex-mex-soft-tacos-met-gehakt-en-guacamole': {
    src: '/images/recepten/tex-mex-soft-tacos-met-gehakt-en-guacamole.jpg',
    alt: {
      nl: 'Recept voor Tex-Mex soft tacos met gehakt en guacamole',
      en: 'Recipe for Tex-Mex soft tacos with minced meat and guacamole'
    }
  },
  'thaise-groene-curry-met-broccoli-en-aubergine': {
    src: '/images/recepten/thaise-groene-curry-met-broccoli-en-aubergine.jpg',
    alt: {
      nl: 'Recept voor Thaise groene curry met broccoli en aubergine',
      en: 'Recipe for Thai green curry with broccoli and eggplant'
    }
  },
  'vegetarische-erwtensoep-met-courgette-en-munt': {
    src: '/images/recepten/vegetarische-erwtensoep-met-courgette-en-munt.jpg',
    alt: {
      nl: 'Recept voor vegetarische erwtensoep met courgette en munt',
      en: 'Recipe for vegetarian pea soup with zucchini and mint'
    }
  },
  'vegetarische-pasta-met-twee-soorten-kaas': {
    src: '/images/recepten/vegetarische-pasta-met-twee-soorten-kaas.jpg',
    alt: {
      nl: 'Recept voor vegetarische pasta met twee soorten kaas',
      en: 'Recipe for vegetarian pasta with two types of cheese'
    }
  },
  'vegetarische-pastasalade-met-spinazie-cherrytomaten-en-pecannoten': {
    src: '/images/recepten/vegetarische-pastasalade-met-spinazie-cherrytomaten-en-pecannoten.jpg',
    alt: {
      nl: 'Recept voor vegetarische pastasalade met spinazie, cherrytomaten en pecannoten',
      en: 'Recipe for vegetarian pasta salad with spinach, cherry tomatoes and pecans'
    }
  },
  'vegetarische-samosas': {
    src: '/images/recepten/indiase-kip-currysoep-met-vegetarische-samosas.jpg',
    alt: {
      nl: 'Recept voor vegetarische samosa’s',
      en: 'Recipe for vegetarian samosas'
    }
  },
  'vegetarische-wraps-met-groenten': {
    src: '/images/recepten/vegetarische-wraps-met-groenten.jpeg',
    alt: {
      nl: 'Recept voor vegetarische wraps met groenten',
      en: 'Recipe for vegetarian wraps with vegetables'
    }
  },
  'vergeten-stamppot-met-knolselderij-en-walnoten': {
    src: '/images/recepten/vergeten-stamppot-met-knolselderij-en-walnoten.jpg',
    alt: {
      nl: 'Recept voor vergeten stamppot met knolselderij en walnoten',
      en: 'Recipe for forgotten mash with celeriac and walnuts'
    }
  },
  'winterse-roti-masala-met-ei-chinese-kool-en-prei': {
    src: '/images/recepten/winterse-roti-masala-met-ei-chinese-kool-en-prei.jpg',
    alt: {
      nl: 'Recept voor winterse roti masala met ei Chinese kool en prei',
      en: 'Recipe for winter roti masala with egg, Chinese cabbage and leek'
    }
  },
  'witte-asperge-quiche': {
    src: '/images/recepten/witte-asperge-quiche.jpg',
    alt: {
      nl: 'Recept voor witte asperge quiche',
      en: 'Recipe for white asparagus quiche'
    }
  },
  'zalm-met-spinazie-a-la-creme-en-een-gekookt-eitje': {
    src: '/images/recepten/zalm-met-spinazie-a-la-creme-en-een-gekookt-eitje.jpg',
    alt: {
      nl: 'Recept voor zalm met spinazie à la crème en een gekookt eitje',
      en: 'Recipe for salmon with creamed spinach and a boiled egg'
    }
  },
  'zalm-quiche-met-spinazie': {
    src: '/images/recepten/zalm-quiche-met-spinazie.jpg',
    alt: {
      nl: 'Recept voor zalm quiche met spinazie',
      en: 'Recipe for salmon quiche with spinach'
    }
  },
  'zalmfilet-met-asperges': {
    src: '/images/recepten/zalmfilet-met-asperges.jpg',
    alt: {
      nl: 'Recept voor zalmfilet met asperges',
      en: 'Recipe for salmon fillet with asparagus'
    }
  },
  'zoete-aardappelhutspot-met-tijm-gehaktballen': {
    src: '/images/recepten/zoete-aardappelhutspot-met-tijm-gehaktballen.jpg',
    alt: {
      nl: 'Recept voor zoete aardappelhutspot met tijm gehaktballen',
      en: 'Recipe for sweet potato mash with thyme meatballs'
    }
  },
  'zoete-dahl-met-abrikozen-en-bloemkool': {
    src: '/images/recepten/zoete-dahl-met-abrikozen-en-bloemkool.jpeg',
    alt: {
      nl: 'Recept voor zoete dahl met abrikozen en bloemkool',
      en: 'Recipe for sweet dahl with apricots and cauliflower'
    }
  }
} as const

export const matchStoryImages = {
  'anjuska-en-bart': {
    src: {
      mobile: '/images/match-verhalen/desktop/anjuska-en-bart.jpeg',
      desktop: '/images/match-verhalen/desktop/anjuska-en-bart.jpeg'
    },
    alt: {
      nl: 'Verhaal van Anjuska en Bart',
      en: 'Story from Anjuska and Bart'
    }
  },
  'anneke-peter-en-dick': {
    src: {
      mobile: '/images/match-verhalen/desktop/anneke-peter-en-dick.jpg',
      desktop: '/images/match-verhalen/desktop/anneke-peter-en-dick.jpg'
    },
    alt: {
      nl: 'Verhaal van Anneke, Peter en Dick',
      en: 'Story from Anneke, Peter and Dick'
    }
  },
  'bosse-en-marinde': {
    src: {
      mobile: '/images/match-verhalen/desktop/bosse-en-marinde.jpg',
      desktop: '/images/match-verhalen/desktop/bosse-en-marinde.jpg'
    },
    alt: {
      nl: 'Verhaal van Bosse en Marinde',
      en: 'Story from Bosse and Marinde'
    }
  },
  'carla-en-sandra': {
    src: {
      mobile: '/images/match-verhalen/mobiel/carla-en-sandra.jpeg',
      desktop: '/images/match-verhalen/desktop/carla-en-sandra.jpeg'
    },
    alt: {
      nl: 'Verhaal van Carla en Sandra',
      en: 'Story from Carla and Sandra'
    }
  },
  'chris-en-ava': {
    src: {
      mobile: '/images/match-verhalen/desktop/chris-en-ava.jpeg',
      desktop: '/images/match-verhalen/desktop/chris-en-ava.jpeg'
    },
    alt: {
      nl: 'Verhaal van Chris en Ava',
      en: 'Story from Chris and Ava'
    }
  },
  'dennis-en-roberto': {
    src: {
      mobile: '/images/match-verhalen/desktop/dennis-en-roberto.jpeg',
      desktop: '/images/match-verhalen/desktop/dennis-en-roberto.jpeg'
    },
    alt: {
      nl: 'Verhaal van Dennis en Roberto',
      en: 'Story from Dennis and Roberto'
    }
  },
  'els-en-gerda': {
    src: {
      mobile: '/images/match-verhalen/desktop/els-en-gerda.jpeg',
      desktop: '/images/match-verhalen/desktop/els-en-gerda.jpeg'
    },
    alt: {
      nl: 'Verhaal van Els en Gerda',
      en: 'Story from Els and Gerda'
    }
  },
  'evy-max-en-nick': {
    src: {
      mobile: '/images/match-verhalen/desktop/evy-max-en-nick.jpg',
      desktop: '/images/match-verhalen/desktop/evy-max-en-nick.jpg'
    },
    alt: {
      nl: 'Verhaal van Evy, Max en Nick',
      en: 'Story from Evy, Max and Nick'
    }
  },
  'floortje-en-koos': {
    src: {
      mobile: '/images/match-verhalen/desktop/floortje-en-koos.jpeg',
      desktop: '/images/match-verhalen/desktop/floortje-en-koos.jpeg'
    },
    alt: {
      nl: 'Verhaal van Floortje en Koos',
      en: 'Story from Floortje and Koos'
    }
  },
  'frans-en-mick': {
    src: {
      mobile: '/images/match-verhalen/desktop/frans-en-mick.jpg',
      desktop: '/images/match-verhalen/desktop/frans-en-mick.jpg'
    },
    alt: {
      nl: 'Verhaal van Frans en Mick',
      en: 'Story from Frans and Mick'
    }
  },
  'gerda-en-rosemarie': {
    src: {
      mobile: '/images/match-verhalen/desktop/gerda-en-rosemarie.jpg',
      desktop: '/images/match-verhalen/desktop/gerda-en-rosemarie.jpg'
    },
    alt: {
      nl: 'Verhaal van Gerda en Rosemarie',
      en: 'Story from Gerda and Rosemarie'
    }
  },
  'guus-en-marie-jose': {
    src: {
      mobile: '/images/match-verhalen/desktop/guus-en-marie-jose.jpg',
      desktop: '/images/match-verhalen/desktop/guus-en-marie-jose.jpg'
    },
    alt: {
      nl: 'Verhaal van Guus en Marie-José',
      en: 'Story from Guus and Marie-José'
    }
  },
  'hans-en-patricia-en-meneer-en-mevrouw-zeven': {
    src: {
      mobile: '/images/match-verhalen/desktop/hans-en-patricia.jpeg',
      desktop: '/images/match-verhalen/desktop/hans-en-patricia.jpeg'
    },
    alt: {
      nl: 'Verhaal van Hans en Patricia en meneer en mevrouw Zeven',
      en: 'Story from Hans and Patricia and Mr. and Mrs. Zeven'
    }
  },
  'hans-en-ylvie': {
    src: {
      mobile: '/images/match-verhalen/desktop/hans-en-ylvie.jpeg',
      desktop: '/images/match-verhalen/desktop/hans-en-ylvie.jpeg'
    },
    alt: {
      nl: 'Verhaal van Hans en Ylvie',
      en: 'Story from Hans and Ylvie'
    }
  },
  'helga-en-nienke': {
    src: {
      mobile: '/images/match-verhalen/desktop/helga-en-nienke.jpeg',
      desktop: '/images/match-verhalen/desktop/helga-en-nienke.jpeg'
    },
    alt: {
      nl: 'Verhaal van Helga en Nienke',
      en: 'Story from Helga and Nienke'
    }
  },
  'hetty-en-ingeborg': {
    src: {
      mobile: '/images/match-verhalen/desktop/hetty-en-ingeborg.jpeg',
      desktop: '/images/match-verhalen/desktop/hetty-en-ingeborg.jpeg'
    },
    alt: {
      nl: 'Verhaal van Hetty en Ingeborg',
      en: 'Story from Hetty and Ingeborg'
    }
  },
  'ingrid-en-bram': {
    src: {
      mobile: '/images/match-verhalen/desktop/ingrid-en-bram.jpeg',
      desktop: '/images/match-verhalen/desktop/ingrid-en-bram.jpeg'
    },
    alt: {
      nl: 'Verhaal van Ingrid en Bram',
      en: 'Story from Ingrid and Bram'
    }
  },
  'janice-en-maartje': {
    src: {
      mobile: '/images/match-verhalen/desktop/janice-en-maartje.jpg',
      desktop: '/images/match-verhalen/desktop/janice-en-maartje.jpg'
    },
    alt: {
      nl: 'Verhaal van Janice en Maartje',
      en: 'Story from Janice and Maartje'
    }
  },
  'jessica-en-yvonne': {
    src: {
      mobile: '/images/match-verhalen/desktop/jessica-en-yvonne.jpeg',
      desktop: '/images/match-verhalen/desktop/jessica-en-yvonne.jpeg'
    },
    alt: {
      nl: 'Verhaal van Jessica en Yvonne',
      en: 'Story from Jessica and Yvonne'
    }
  },
  'job-en-michael': {
    src: {
      mobile: '/images/match-verhalen/mobiel/job-en-michael.jpg',
      desktop: '/images/match-verhalen/desktop/job-en-michael.jpeg'
    },
    alt: {
      nl: 'Verhaal van Job en Michael',
      en: 'Story from Job and Michael'
    }
  },
  'john-en-pauline': {
    src: {
      mobile: '/images/match-verhalen/desktop/john-en-pauline.jpg',
      desktop: '/images/match-verhalen/desktop/john-en-pauline.jpg'
    },
    alt: {
      nl: 'Verhaal van John en Pauline',
      en: 'Story from John and Pauline'
    }
  },
  'jonella-en-annabel': {
    src: {
      mobile: heroImages['suryono-met-dressing'].src,
      desktop: heroImages['suryono-met-dressing'].src
    },
    alt: {
      nl: 'Verhaal van Jonella en Annabel',
      en: 'Story from Jonella and Annabel'
    }
  },
  'lena-en-jenneken': {
    src: {
      mobile: '/images/match-verhalen/desktop/lena-en-jenneken.jpg',
      desktop: '/images/match-verhalen/desktop/lena-en-jenneken.jpg'
    },
    alt: {
      nl: 'Verhaal van Lena en Jenneken',
      en: 'Story from Lena and Jenneken'
    }
  },
  'lijda-en-rashmi': {
    src: {
      mobile: '/images/match-verhalen/mobiel/lijda-en-rashmi.jpeg',
      desktop: '/images/match-verhalen/desktop/lijda-en-rashmi.jpg'
    },
    alt: {
      nl: 'Verhaal van Lijda en Rashmi',
      en: 'Story from Lijda and Rashmi'
    }
  },
  'maaike-en-valery': {
    src: {
      mobile: '/images/match-verhalen/desktop/valery-en-maaike.jpeg',
      desktop: '/images/match-verhalen/desktop/valery-en-maaike.jpeg'
    },
    alt: {
      nl: 'Verhaal van Maaike en Valery',
      en: 'Story from Maaike and Valery'
    }
  },
  'marja-en-dionne': {
    src: {
      mobile: '/images/match-verhalen/desktop/marja-en-dionne.jpeg',
      desktop: '/images/match-verhalen/desktop/marja-en-dionne.jpeg'
    },
    alt: {
      nl: 'Verhaal van Marja en Dionne',
      en: 'Story from Marja and Dionne'
    }
  },
  'marjolein-en-marja': {
    src: {
      mobile: '/images/match-verhalen/desktop/marjolein-en-marja.jpeg',
      desktop: '/images/match-verhalen/desktop/marjolein-en-marja.jpeg'
    },
    alt: {
      nl: 'Verhaal van Marjolein en Marja',
      en: 'Story from Marjolein and Marja'
    }
  },
  'marjolein-en-sjaan': {
    src: {
      mobile: '/images/match-verhalen/mobiel/marjolein-en-sjaan.jpeg',
      desktop: '/images/match-verhalen/desktop/marjolein-en-sjaan.jpeg'
    },
    alt: {
      nl: 'Verhaal van Marjolein en Sjaan',
      en: 'Story from Marjolein and Sjaan'
    }
  },
  'marloes-en-aad': {
    src: {
      mobile: '/images/match-verhalen/desktop/marloes-en-aad.jpg',
      desktop: '/images/match-verhalen/desktop/marloes-en-aad.jpg'
    },
    alt: {
      nl: 'Verhaal van Marloes en Aad',
      en: 'Story from Marloes and Aad'
    }
  },
  'nanda-en-corrie': {
    src: {
      mobile: '/images/match-verhalen/desktop/nanda-en-corrie.jpeg',
      desktop: '/images/match-verhalen/desktop/nanda-en-corrie.jpeg'
    },
    alt: {
      nl: 'Verhaal van Nanda en Corrie',
      en: 'Story from Nanda and Corrie'
    }
  },
  'renate-aat-en-diek': {
    src: {
      mobile: '/images/match-verhalen/desktop/renate-aat-en-diek.jpeg',
      desktop: '/images/match-verhalen/desktop/renate-aat-en-diek.jpeg'
    },
    alt: {
      nl: 'Verhaal van Renate, Aat en Diek',
      en: 'Story from Renate, Aat and Diek'
    }
  },
  'nikki-en-anouk': {
    src: {
      mobile: '/images/match-verhalen/desktop/nikki-en-anouk.jpg',
      desktop: '/images/match-verhalen/desktop/nikki-en-anouk.jpg'
    },
    alt: {
      nl: 'Verhaal van Nikki en Anouk',
      en: 'Story from Nikki and Anouk'
    }
  },
  'tara-en-meike': {
    src: {
      mobile: '/images/match-verhalen/desktop/tara-en-meike.jpeg',
      desktop: '/images/match-verhalen/desktop/tara-en-meike.jpeg'
    },
    alt: {
      nl: 'Verhaal van Tara en Meike',
      en: 'Story from Tara and Meike'
    }
  },
  'tessa-en-sanne': {
    src: {
      mobile: '/images/match-verhalen/desktop/tessa-en-sanne.jpg',
      desktop: '/images/match-verhalen/desktop/tessa-en-sanne.jpg'
    },
    alt: {
      nl: 'Verhaal van Tessa en Sanne',
      en: 'Story from Tessa and Sanne'
    }
  },
  'tina-en-laura': {
    src: {
      mobile: '/images/match-verhalen/desktop/tina-en-laura.jpg',
      desktop: '/images/match-verhalen/desktop/tina-en-laura.jpg'
    },
    alt: {
      nl: 'Verhaal van Tina en Laura',
      en: 'Story from Tina and Laura'
    }
  },
  'ton-en-cees': {
    src: {
      mobile: '/images/match-verhalen/desktop/ton-en-cees.jpeg',
      desktop: '/images/match-verhalen/desktop/ton-en-cees.jpeg'
    },
    alt: {
      nl: 'Verhaal van Ton en Cees',
      en: 'Story from Ton and Cees'
    }
  },
  'valery-en-maaike': {
    src: {
      mobile: '/images/match-verhalen/desktop/valery-en-maaike.jpeg',
      desktop: '/images/match-verhalen/desktop/valery-en-maaike.jpeg'
    },
    alt: {
      nl: 'Verhaal van Valery en Maaike',
      en: 'Story from Valery and Maaike'
    }
  },
  'willemijn-en-sandra': {
    src: {
      mobile: '/images/match-verhalen/mobiel/willemijn-en-sandra.jpeg',
      desktop: '/images/match-verhalen/desktop/willemijn-en-sandra.jpeg'
    },
    alt: {
      nl: 'Verhaal van Willemijn en Sandra',
      en: 'Story from Willemijn and Sandra'
    }
  },
  'wim-en-niki': {
    src: {
      mobile: '/images/match-verhalen/desktop/wim-en-niki.jpeg',
      desktop: '/images/match-verhalen/desktop/wim-en-niki.jpeg'
    },
    alt: {
      nl: 'Verhaal van Wim en Niki',
      en: 'Story from Wim and Niki'
    }
  }
} as const
